import React, { useEffect, useState } from "react";
import { conf } from "../const";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { currentFormat } from "../js/main";
import moment from "moment";

export default function Delivery() {
  const [report, setReport] = useState();
  const styles = {
    td: { fontSize: "9pt", border: "1px solid #111", padding: "3px 3px" },
    total: {
      fontSize: "9pt",
      borderBottom: "1px solid #111",
      padding: "3px 3px",
    },
  };
  useEffect(() => {
    const cookie = JSON.parse(localStorage.getItem(conf.cookiePrint));
    if (!cookie.print.create_date) cookie.print.create_date = new Date();
    setReport(cookie.print);
  }, []);
  useEffect(() => {
    if (report) {
      setTimeout(() => window.print(), 500);
    }
  }, [report]);

  return (
    <div
      style={{
        textAlign: "center",
        margin: "auto",
        width: "20.5cm",
      }}
    >
      {report && (
        <>
          <h2 className="bold">{report.headers[0].label}</h2>
          <div className="bold" style={{ marginBottom: "15px" }}>
            {report.headers[1].label}
          </div>
          <div
            style={{
              textAlign: "right",
              fontSize: "9pt",
              paddingBottom: "5px",
            }}
          >
            ณ วันที่ {moment(report.create_date).format("DD MMMM YYYY, HH:mm")}
          </div>
          <TableContainer>
            <Table size="small" sx={{ border: "1px solid #111" }}>
              <TableHead>
                <TableRow>
                  {report.table.cols.map((col, key) => (
                    <TableCell
                      key={key}
                      sx={{
                        ...col.style,
                        ...styles.td,
                      }}
                    >
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {report.table.rows.map((row, key) => (
                  <TableRow key={key}>
                    <TableCell sx={styles.td}>
                      {row.col_0.map((col, key) => (
                        <div key={key}>
                          {key + 1}. {col.label}
                        </div>
                      ))}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {row.col_1}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {row.col_2}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {row.col_3}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {row.col_4}
                    </TableCell>
                    <TableCell
                      sx={{ ...{ color: "#f00" }, ...styles.td }}
                      align="center"
                    >
                      {row.col_5}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    sx={styles.total}
                    colSpan={4}
                    className="bold"
                    align="right"
                  >
                    รวมเป็นเงิน
                  </TableCell>
                  <TableCell className="bold" align="right" sx={styles.total}>
                    {currentFormat(report.table.total.amount)}
                  </TableCell>
                  <TableCell className="bold" sx={styles.total}>
                    บาท
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={4}
                    className="bold"
                    align="right"
                    sx={styles.total}
                  >
                    เงินสด
                  </TableCell>
                  <TableCell className="bold" align="right" sx={styles.total}>
                    {currentFormat(report.table.total.cash)}
                  </TableCell>
                  <TableCell className="bold" sx={styles.total}>
                    บาท
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={4}
                    className="bold"
                    align="right"
                    sx={styles.total}
                  >
                    เงินโอน
                  </TableCell>
                  <TableCell className="bold" align="right" sx={styles.total}>
                    {currentFormat(report.table.total.transfer)}
                  </TableCell>
                  <TableCell className="bold" sx={styles.total}>
                    บาท
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={4}
                    className="bold"
                    align="right"
                    sx={styles.total}
                  >
                    รายการยกเลิก
                  </TableCell>
                  <TableCell className="bold" align="right" sx={styles.total}>
                    {report.table.total.canceled_count}
                  </TableCell>
                  <TableCell className="bold" sx={styles.total}>
                    รายการ
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div
            style={{
              marginTop: "2.2cm",
              paddingLeft: "11cm",
              textAlign: "center",
            }}
          >
            {report.create_usn && <div>{report.create_usn}</div>}
            <div style={{ marginTop: "-0.2cm" }}>
              ..........................................................
            </div>
            <div
              style={{
                paddingTop: ".2cm",
                fontSize: "10pt",
              }}
              className="bold"
            >
              ผู้ส่งเงิน
            </div>
          </div>
        </>
      )}
    </div>
  );
}
